import React, { useState } from 'react';
import { NAV_LINKS } from '../data/constants';
import { scrollToSection } from '../utils/scrollTo';

const Navbar: React.FC = () => {
  const [active, setActive] = useState('About');
  const [open, setOpen] = useState(false);
  const go = (link: string) => { setActive(link); scrollToSection(link === 'Why GRP' ? 'why-grp' : link.toLowerCase()); setOpen(false); };
  return (
    <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 999 }}>
      <div className="nav-root">
        <div className="nav-inner">
          <img src="/logo.png" alt="Gulf Fibertech Industries" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            style={{ height: 100, width: 'auto', objectFit: 'contain', objectPosition: 'left center', cursor: 'pointer' }} />
          <div className="nav-links">
            {NAV_LINKS.map(link => (
              <button key={link} className={`nav-link ${active === link ? 'active' : ''}`} onClick={() => go(link)}>{link}</button>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10 }}>
            <button className="nav-cta" onClick={() => go('Contact')}>Get a Quote</button>
            <button className="nav-mobile-btn" onClick={() => setOpen(p => !p)} aria-label="menu">
              {[0, 1, 2].map(i => <span key={i} style={{ transform: open && i === 0 ? 'rotate(45deg) translate(5px,5px)' : open && i === 2 ? 'rotate(-45deg) translate(5px,-5px)' : open && i === 1 ? 'scaleX(0)' : 'none' }} />)}
            </button>
          </div>
        </div>
      </div>
      {open && (
        <div className="nav-dropdown">
          {NAV_LINKS.map(link => <div key={link} className={`nav-dropdown-item ${active === link ? 'act' : ''}`} onClick={() => go(link)}>{link}</div>)}
          <button className="btn-yellow" style={{ marginTop: 16, width: '100%' }} onClick={() => go('Contact')}>Get a Quote</button>
        </div>
      )}
    </nav>
  );
};
export default Navbar;
